import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import {
  ArrowsLeftRight,
  ChartLineUp,
  Compass,
  FolderSimple,
  MapTrifold,
  Question,
  SignOut,
  UsersThree,
} from "@phosphor-icons/react";

const NAV = [
  { to: "/dashboard", label: "Dashboard", icon: ChartLineUp },
  { to: "/analisis", label: "Nuevo análisis", icon: Compass },
  { to: "/proyectos", label: "Proyectos guardados", icon: FolderSimple },
  { to: "/zonificacion", label: "Zonificación", icon: MapTrifold },
  { to: "/ayuda", label: "Ayuda", icon: Question },
];

const ADMIN_NAV = [
  { to: "/admin/usuarios", label: "Usuarios", icon: UsersThree },
];

export default function AppShell() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="h-screen w-screen flex bg-[#0A0A0A] text-white overflow-hidden">
      <aside
        className="w-60 shrink-0 border-r border-white/10 bg-[#0A0A0A] flex flex-col"
        data-testid="app-sidebar"
      >
        <div className="px-5 py-5 border-b border-white/10 flex items-center gap-3">
          <div className="w-8 h-8 border border-[#FF9800] flex items-center justify-center">
            <ArrowsLeftRight size={18} weight="bold" className="text-[#FF9800]" />
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">
              MATRIZ
            </p>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white">
              O / D · MITMA
            </p>
          </div>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
          {NAV.map((n) => {
            const Icon = n.icon;
            return (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.to.replace("/", "")}`}
                className={({ isActive }) =>
                  `group flex items-center gap-3 px-3 py-2.5 text-sm border border-transparent btn-press transition-colors ${
                    isActive
                      ? "bg-[#1A1A1A] border-white/10 text-white"
                      : "text-white/60 hover:text-white hover:bg-white/[0.03]"
                  }`
                }
              >
                <Icon size={18} weight="bold" className="shrink-0" />
                <span className="tracking-tight">{n.label}</span>
              </NavLink>
            );
          })}

          {user?.role === "admin" && (
            <div className="pt-4 mt-3 border-t border-white/10">
              <p className="px-3 mb-2 label-micro text-[#FF9800]">ADMIN</p>
              {ADMIN_NAV.map((n) => {
                const Icon = n.icon;
                return (
                  <NavLink
                    key={n.to}
                    to={n.to}
                    data-testid={`nav-${n.to.replace(/\//g, "-").replace(/^-/, "")}`}
                    className={({ isActive }) =>
                      `group flex items-center gap-3 px-3 py-2.5 text-sm border border-transparent btn-press transition-colors ${
                        isActive
                          ? "bg-[#1A1A1A] border-[#FF9800]/30 text-[#FF9800]"
                          : "text-white/60 hover:text-[#FF9800] hover:bg-white/[0.03]"
                      }`
                    }
                  >
                    <Icon size={18} weight="bold" className="shrink-0" />
                    <span className="tracking-tight">{n.label}</span>
                  </NavLink>
                );
              })}
            </div>
          )}
        </nav>

        <div className="px-3 py-4 border-t border-white/10 space-y-2">
          <div className="px-3 py-2">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">
              Conectado
            </p>
            <p className="text-sm text-white truncate" data-testid="sidebar-user-name">
              {user?.name || user?.email}
            </p>
            <p className="text-xs text-white/40 truncate">{user?.email}</p>
          </div>
          <button
            onClick={onLogout}
            data-testid="logout-btn"
            className="w-full flex items-center gap-3 px-3 py-2 text-sm text-white/60 hover:text-[#F44336] hover:bg-[#F44336]/5 border border-transparent hover:border-[#F44336]/20 transition-colors btn-press"
          >
            <SignOut size={18} weight="bold" />
            Cerrar sesión
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-hidden">
        <Outlet />
      </main>
    </div>
  );
}
